import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPerson = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.75 8a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM12 3.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5ZM4.75 20A4.25 4.25 0 0 1 9 15.75h6A4.25 4.25 0 0 1 19.25 20a.75.75 0 0 0 1.5 0A5.75 5.75 0 0 0 15 14.25H9A5.75 5.75 0 0 0 3.25 20a.75.75 0 0 0 1.5 0Z",
		clipRule: "evenodd"
	})
});
export default SvgPerson;
